export default __webpack_public_path__ + "static/238-e45189569ae47ce5c527cbef8d7dce34.mp4";